import {
    advanceIntervalScheduleCursor,
    type IntervalSchedule,
    type IntervalScheduleCursor,
    peekNextIntervalDurationMs
} from "../state/interval-schedule";

// Run a setTimeout chain driven by `cursor` against `schedule`. Each tick
// advances the cursor and calls `onTick(stepIndex)`, then queues the next.
export class IntervalLoop {
    private started = false;
    private timeoutId: ReturnType<typeof setTimeout> | undefined;
    private readonly schedule: IntervalSchedule;
    private readonly cursor: IntervalScheduleCursor;
    private readonly onTick: (stepIndex: number) => void;

    public constructor(
        schedule: IntervalSchedule,
        cursor: IntervalScheduleCursor,
        onTick: (stepIndex: number) => void
    ) {
        this.schedule = schedule;
        this.cursor = cursor;
        this.onTick = onTick;
    }

    public start = () => {
        if (this.started) {
            return;
        }
        this.started = true;
        this.scheduleNext();
    };

    public stop = () => {
        if (!this.started) {
            return;
        }
        this.started = false;
        if (this.timeoutId !== undefined) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    };

    private readonly scheduleNext = () => {
        if (!this.started) {
            return;
        }
        const ms = peekNextIntervalDurationMs(this.schedule, this.cursor);
        this.timeoutId = setTimeout(() => {
            if (!this.started) {
                return;
            }
            const consumedStep = advanceIntervalScheduleCursor(this.cursor);
            try {
                this.onTick(consumedStep);
            } finally {
                this.scheduleNext();
            }
        }, ms);
    };
}
